"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommandType = void 0;
var CommandType = exports.CommandType = /*#__PURE__*/function (CommandType) {
  CommandType[CommandType["Error"] = 0] = "Error";
  CommandType[CommandType["StartGameResponse"] = 1] = "StartGameResponse";
  CommandType[CommandType["PlayerLocked"] = 2] = "PlayerLocked";
  CommandType[CommandType["GameUnavailable"] = 3] = "GameUnavailable";
  CommandType[CommandType["UnknownIntegrationId"] = 4] = "UnknownIntegrationId";
  CommandType[CommandType["Maintenance"] = 5] = "Maintenance";
  CommandType[CommandType["SpinResponse"] = 8] = "SpinResponse";
  CommandType[CommandType["ServerTime"] = 9] = "ServerTime";
  CommandType[CommandType["BalanceResponse"] = 10] = "BalanceResponse";
  CommandType[CommandType["PayLineWinResponse"] = 11] = "PayLineWinResponse";
  CommandType[CommandType["FeatureWinResponse"] = 12] = "FeatureWinResponse";
  CommandType[CommandType["FeatureEndResponse"] = 13] = "FeatureEndResponse";
  CommandType[CommandType["RoundEndResponse"] = 18] = "RoundEndResponse";
  CommandType[CommandType["GameConfigurationResponse"] = 14] = "GameConfigurationResponse";
  CommandType[CommandType["BlitzStartResponse"] = 15] = "BlitzStartResponse";
  CommandType[CommandType["SessionExpired"] = 16] = "SessionExpired";
  CommandType[CommandType["InfoMessageResponse"] = 17] = "InfoMessageResponse";
  CommandType[CommandType["PromotionAvailableResponse"] = 19] = "PromotionAvailableResponse";
  CommandType[CommandType["PromotionEndResponse"] = 20] = "PromotionEndResponse";
  CommandType[CommandType["SetBetResponse"] = 21] = "SetBetResponse";
  CommandType[CommandType["SetReelsResponse"] = 22] = "SetReelsResponse";
  CommandType[CommandType["UnfinishedGameResponse"] = 23] = "UnfinishedGameResponse";
  CommandType[CommandType["RoundStartResponse"] = 24] = "RoundStartResponse";
  CommandType[CommandType["PayLineEndResponse"] = 25] = "PayLineEndResponse";
  CommandType[CommandType["BlitzStopResponse"] = 26] = "BlitzStopResponse";
  CommandType[CommandType["PromotionStartResponse"] = 27] = "PromotionStartResponse";
  CommandType[CommandType["SpinEndResponse"] = 28] = "SpinEndResponse";
  CommandType[CommandType["RoundDebugResponse"] = 29] = "RoundDebugResponse";
  CommandType[CommandType["PayWayWinResponse"] = 30] = "PayWayWinResponse";
  CommandType[CommandType["PayWayEndResponse"] = 31] = "PayWayEndResponse";
  CommandType[CommandType["ReplayResponse"] = 32] = "ReplayResponse";
  CommandType[CommandType["IdentifierResponse"] = 33] = "IdentifierResponse";
  CommandType[CommandType["PlayerActionResponse"] = 34] = "PlayerActionResponse";
  CommandType[CommandType["ResumeGameResponse"] = 35] = "ResumeGameResponse";
  CommandType[CommandType["GameReadyResponse"] = 36] = "GameReadyResponse";
  CommandType[CommandType["ContinueWaitResponse"] = 37] = "ContinueWaitResponse";
  CommandType[CommandType["IdentifierRequest"] = 1000] = "IdentifierRequest";
  CommandType[CommandType["StartGameRequest"] = 1001] = "StartGameRequest";
  CommandType[CommandType["SpinRequest"] = 1002] = "SpinRequest";
  CommandType[CommandType["CollectRequest"] = 1003] = "CollectRequest";
  CommandType[CommandType["GambleRequest"] = 1004] = "GambleRequest";
  CommandType[CommandType["ExitRequest"] = 1005] = "ExitRequest";
  CommandType[CommandType["BalanceRequest"] = 1010] = "BalanceRequest";
  CommandType[CommandType["BlitzStartRequest"] = 1011] = "BlitzStartRequest";
  CommandType[CommandType["PromotionStartRequest"] = 1012] = "PromotionStartRequest";
  CommandType[CommandType["PromotionStopRequest"] = 1013] = "PromotionStopRequest";
  CommandType[CommandType["KeepAliveRequest"] = 1014] = "KeepAliveRequest";
  CommandType[CommandType["BlitzStopRequest"] = 1015] = "BlitzStopRequest";
  CommandType[CommandType["AckRequest"] = 1016] = "AckRequest";
  CommandType[CommandType["StatEventRequest"] = 1017] = "StatEventRequest";
  CommandType[CommandType["ReplayRequest"] = 1018] = "ReplayRequest";
  CommandType[CommandType["PlayerActionRequest"] = 1019] = "PlayerActionRequest";
  CommandType[CommandType["ContinueRequest"] = 1021] = "ContinueRequest";
  return CommandType;
}({});
//# sourceMappingURL=CommandType.js.map